module.exports = __webpack_public_path__ + "static/media/1 Mintues Final_3rd RAC Meeting_FINAL 27 Aug 2021.c18f92aa.pdf";